import { api_url } from "../configiration/config";
import { axiosClone } from "./../axiosClone";
import axios from 'axios';

// get blog sections
export async function getcontactusSettings(){
    return await axiosClone.get(`${api_url}/contact-us`);
}
//post contact Message
export async function sendContactMsg(contactData){
    return await axios({
        url: `${api_url}/contact-us`,
        method: 'post',
        data: contactData
    })
}